import { memo } from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { Opacity } from '@mui/icons-material';

import { IMAGESERVICEURL } from './SinglePage';

const FastSAMImageList = ({objects, clickfn, selectedimg})=>{
    if (objects===undefined){
        return (<></>);
    }
    const opa = (id)=>{
        return selectedimg===id?1.0:0.5;
    }
    const itemData = [...Array(objects).keys()].map(i =>{
        return {
            src: IMAGESERVICEURL+"/lastfastsam/thumbimage/"+i,
            id: i,
            cb: clickfn,
            title: "FastSam_"+i};
    });
        
    return (
    <ImageList variant="quilted" sx={{ width: 1024, height: 450 }} cols={4} rowHeight={230}>
      {itemData.map((item) => (
        <ImageListItem key={item.id}>
          <img
            style={{opacity:opa(item.id)}}
            srcSet={`${item.src}`}
            src={`${item.src}`}
            alt={item.title}
            onClick={(e) => item.cb(item.id)}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

export default memo(FastSAMImageList);

/*export default function FastSAMImageList(prop) {
    const itemData = [...Array(prop.objects).keys()].map(i =>{
        return {
            src: "http://localhost:8181/cxf/eyeprocessor/lastfastsam/thumbimage/"+i,
            id: i,
            cb: prop.clickfn,
            title: "FastSam_"+i};
    });
        
    return (
    <ImageList variant="quilted" sx={{ width: 500, height: 450 }} cols={2} rowHeight={230}>
      {itemData.map((item) => (
        <ImageListItem key={item.id}>
          <img
            srcSet={`${item.src}`}
            src={`${item.src}`}
            alt={item.title}
            onClick={(e) => item.cb(item.id)}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}*/

